
export const getRoute = (path: string): string => {
    if(routes[path as keyof typeof routes]) return routes[path as keyof typeof routes]
    return path
}

export const getLink = (path: string): string => {
    if(links[path as keyof typeof links]) return links[path as keyof typeof links]
    return path
}

const routes = {
    users: 'Accounts',
    games: 'Pull-Tab Games',
    boxes: 'Pull-Tab Decks',
    bingoconfig: 'Bingo Configuration',
    bingogames: 'Bingo Games',
    drawermanagement: 'Drawer Management',
    gameorderings: 'lobby Order',
    posbundleservermanagement: 'POS Bundle Server Management',
    bingogamelist: 'Bingo definitions',
    decksstatus: 'Decks Status',
    queuestatus: 'Generator Queue Status',
    deviceversions: 'Device Versions',
    drawercashiers: 'Drawer Cashier Management',
    logs: 'System Logs',
    decksmanagement: 'Decks Management',
    manufacturerconfig: 'System Configuration',
    locationtopology: 'Location Topology',
    migrationstatus: 'Migration Status',
    jackpotspayrolls: 'Jackpot Payments',
    migrationqueue: 'Migration Queue',
    jackpotshistory: 'Jackpot History',
    bundlemanagement: 'Game Bundle Management',
    lobbytabs: 'Lobby Tabs'
}

const links = {
    users: '/users',
    games: '/games/list',
    boxes: '/boxes/list',
    bingoconfig: '/bingoconfig',
    bingogames: '/bingogames',
    drawermanagement: '/drawermanagement',
    gameorderings: '/gameorderings',
    posbundleservermanagement: '/posbundleservermanagement',
    bingogamelist: '/bingogamelist',
    decksstatus: '/decksstatus/list',
    queuestatus: '/queuestatus',
    deviceversions: '/deviceversions/list',
    drawercashiers: '/drawercashiers',
    logs: '/logs',
    decksmanagement: '/decksmanagement',
    manufacturerconfig: '/manufacturerconfig',
    messaging: '/messaging',
    locationtopology: '/locationtopology',
    migrationstatus: '/migrationstatus',
    jackpotspayrolls: '/jackpotspayrolls/list',
    migrationqueue: '/migrationqueue',
    jackpotshistory: '/jackpotshistory/list',
    jackpots: '/jackpots/list',
    distributors: '/distributors',
    charities: '/charities',
    locations: '/locations',
    devices: '/devices/list',
    devicebulkedit: '/devices/bulkedit',
    cashiers: '/cashiers',
    roles: '/roles',
}

